/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SoldInputs */

const en_val_sold = /** @type {(inputs: Val_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold`)
};

const id_val_sold = /** @type {(inputs: Val_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terjual`)
};

/** @type {(inputs: Val_SoldInputs) => LocalizedString} */
const es_val_sold = en_val_sold;

/** @type {(inputs: Val_SoldInputs) => LocalizedString} */
const fr_val_sold = en_val_sold;

/** @type {(inputs: Val_SoldInputs) => LocalizedString} */
const de_val_sold = en_val_sold;

/** @type {(inputs: Val_SoldInputs) => LocalizedString} */
const ja_val_sold = en_val_sold;

/** @type {(inputs: Val_SoldInputs) => LocalizedString} */
const zh_val_sold = en_val_sold;

/** @type {(inputs: Val_SoldInputs) => LocalizedString} */
const ar_val_sold = en_val_sold;

/** @type {(inputs: Val_SoldInputs) => LocalizedString} */
const it_val_sold = en_val_sold;

/** @type {(inputs: Val_SoldInputs) => LocalizedString} */
const ru_val_sold = en_val_sold;

/** @type {(inputs: Val_SoldInputs) => LocalizedString} */
const pt_val_sold = en_val_sold;

/** @type {(inputs: Val_SoldInputs) => LocalizedString} */
const ko_val_sold = en_val_sold;

/**
* | output |
* | --- |
* | "Sold" |
*
* @param {Val_SoldInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_sold = /** @type {((inputs?: Val_SoldInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SoldInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_sold(inputs)
	if (locale === "es") return es_val_sold(inputs)
	if (locale === "fr") return fr_val_sold(inputs)
	if (locale === "de") return de_val_sold(inputs)
	if (locale === "ja") return ja_val_sold(inputs)
	if (locale === "zh") return zh_val_sold(inputs)
	if (locale === "ar") return ar_val_sold(inputs)
	if (locale === "id") return id_val_sold(inputs)
	if (locale === "it") return it_val_sold(inputs)
	if (locale === "ru") return ru_val_sold(inputs)
	if (locale === "pt") return pt_val_sold(inputs)
	return ko_val_sold(inputs)
});